
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Ertigaonrentinpune() {



    const cardData =
    {
        keyword: ' Ertiga on Rent in Pune',
        heading: 'Prince Cabs: Ertiga on Rent in Pune',
        headingDescription: 'Prince Cabs provides affordable Ertiga on Rent in Pune, perfect for family trips, corporate travel, airport transfers, and outstation journeys. Our spacious and well-maintained Ertiga cars come equipped with modern features to ensure a safe, comfortable, and enjoyable ride. With professional chauffeurs, flexible booking options, and transparent pricing, we make travel in and around Pune hassle-free. Choose Prince Cabs’ trusted Ertiga rental service in Pune for reliability, comfort, and affordability.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the grand seat of the Peshwas of the Maratha Empire. Its towering gates, expansive courtyards, and old ruins still narrate stories of valor and intrigue. Though damaged by fire in 1828, it remains a proud symbol of Pune’s history. The evening light-and-sound show brings alive Maratha tales. Tourists love exploring its gardens and ramparts. Shaniwar Wada is Pune’s most iconic heritage fort."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is one of Pune’s most important landmarks. It played a vital role in India’s freedom struggle, as Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. Today, it houses a museum with artifacts, photographs, and memorabilia of Gandhi. Its sprawling gardens provide peace and beauty. Recognized as a national monument, it symbolizes patriotism and sacrifice. It is a must-visit for history lovers."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 30 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare. Its bastions, watchtowers, and ruins tell stories of bravery and resistance. Trekkers love climbing the fort, especially during monsoon when the hills turn lush green. The summit offers breathtaking views of the Sahyadris. Local stalls selling pithla-bhakri add to the experience. Sinhagad is a blend of history, trekking, and natural beauty."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious shrine. The idol of Lord Ganesha, adorned with gold ornaments, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of celebrations. It is also renowned for social and charitable contributions. Its central location makes it easily accessible to all. Dagdusheth Temple is both a spiritual and cultural pride of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of the highest points in Pune, offers panoramic views of the city. At the top lies the Parvati Temple complex dedicated to Lord Shiva and Goddess Parvati. Visitors climb more than 100 steps to reach the shrine. The Peshwa Museum nearby preserves Maratha-era artifacts. Sunsets and sunrises from the hill are breathtaking. It is a serene escape combining devotion, history, and scenic charm."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum with a Shiva linga, and a stone-carved Nandi. Despite its central location, it offers a calm and meditative ambiance. The temple reflects Rashtrakuta-era architecture. It is admired for its simplicity and spiritual significance. Pataleshwar is one of Pune’s hidden heritage gems."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure of over 20,000 artifacts collected by Dr. Dinkar Kelkar. It includes musical instruments, sculptures, ornaments, and the recreated Mastani Mahal. The museum reflects India’s cultural richness and artistry. Art lovers and historians find it fascinating. The three-story heritage structure adds charm to the experience. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "Osho International Meditation Resort in Koregaon Park is a globally known spiritual retreat. Visitors from around the world come here for meditation, yoga, and wellness therapies. Surrounded by serene gardens and modern architecture, it offers peace and rejuvenation. The ashram promotes holistic living and mindfulness. Its vibrant international community adds cosmopolitan flavor. It is a unique blend of spirituality and modern lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and lifestyle destination. It features international and Indian brands, multiplex cinemas, and gaming zones. Families enjoy its entertainment options and fine dining restaurants. Seasonal festivals and live events add to the vibrancy. It reflects Pune’s modern and urban side. Phoenix Marketcity is the ultimate hub for shopping and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a popular picnic and weekend getaway. It provides water to the city and is surrounded by green hills. Families enjoy boating, evening walks, and local street food. During monsoon, the reservoir looks stunning with mist and lush surroundings. The cool breeze makes evenings refreshing. Khadakwasla is Pune’s peaceful natural retreat."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a beautiful outstation escape near Pune. Surrounded by Sahyadri hills, waterfalls, and forests, it is ideal for camping, boating, and photography. Monsoon enhances its charm with overflowing streams and misty landscapes. Eco-resorts nearby provide cozy stays. It is loved by families, couples, and nature lovers alike. Mulshi is a perfect mix of adventure and relaxation."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, situated on Senapati Bapat Road, is one of Pune’s oldest and most revered shrines. Dedicated to Goddess Chaturshringi, devotees climb over 100 steps to reach the sanctum. The temple is most vibrant during Navratri with colorful festivities. Thousands of pilgrims visit for blessings throughout the year. The hilltop location also provides great city views. It is both spiritual and cultural in significance."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial honors soldiers who sacrificed their lives post-independence. It showcases tanks, weapons, and war memorabilia. A museum inside narrates India’s military history and valor. The evening flag retreat ceremony is especially moving. Families and students visit to instill patriotism and pride. It is both an educational and emotional landmark in Pune."
  },
  {
    "title": "Empress Garden",
    "description": "Spread across 39 acres, Empress Garden is one of Pune’s oldest botanical parks. Managed by the Agri-Horticultural Society, it houses exotic plants, shaded pathways, and flower nurseries. Families enjoy picnics and leisure time here. The annual flower show attracts nature enthusiasts. The garden also carries colonial heritage charm. Empress Garden is Pune’s green oasis."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, the highest hill in Pune, is a popular spot for joggers, trekkers, and cyclists. The hilltop offers sweeping views of the city and surrounding landscapes. It is rich in biodiversity, making it attractive for birdwatchers and nature lovers. Early mornings and evenings are especially refreshing. Sunrises and sunsets from here are stunning. Vetal Tekdi is Pune’s natural retreat and a breath of fresh air."
  }
],

"services": [
  {
    "name": "Ertiga Rental Pune",
    "description": "Get reliable Ertiga rental services in Pune for local and outstation travel. This spacious 7-seater is ideal for families, group trips, business outings, and weekend getaways, offering comfort, space, and affordability in one package."
  },
  {
    "name": "Ertiga Hire with Driver Pune",
    "description": "Hire an Ertiga in Pune with a professional driver for a stress-free travel experience. Whether you’re planning a long trip, a local outing, or need a cab for daily use, our drivers ensure safe and smooth journeys every time."
  },
  {
    "name": "7 Seater Ertiga Car Pune",
    "description": "Book a 7-seater Ertiga in Pune for convenient and comfortable travel. With ample space for passengers and luggage, it’s perfect for joint family rides, group tours, or events requiring group transportation."
  },
  {
    "name": "Pune to Mumbai Ertiga Booking",
    "description": "Travel from Pune to Mumbai in an Ertiga for a hassle-free journey. Enjoy door-to-door service, professional chauffeurs, AC comfort, and competitive pricing for one-way and round-trip bookings."
  },
  {
    "name": "Pune to Goa Ertiga Tour",
    "description": "Plan an exciting Pune to Goa trip in an Ertiga cab. With its spacious interiors and smooth suspension, it ensures a relaxing ride along the scenic Konkan coast — ideal for beach vacations and group travel."
  },
  {
    "name": "Ertiga for Outstation Pune",
    "description": "Book an Ertiga for your outstation travel needs from Pune. Whether heading to Mumbai, Lonavala, Nashik, or Shirdi, this vehicle offers perfect balance between comfort, safety, and fuel economy."
  },
  {
    "name": "Ertiga Cab for Family Trip Pune",
    "description": "Perfect for family travel, our Ertiga cabs in Pune are spacious, clean, and driven by courteous chauffeurs. Book now for picnics, sightseeing, weddings, or spiritual tours with your loved ones."
  },
  {
    "name": "Ertiga on Rent Viman Nagar",
    "description": "Rent an Ertiga in Viman Nagar for all your travel requirements — local use, business travel, or intercity tours. Convenient booking, competitive rates, and timely service included."
  },
  {
    "name": "Ertiga Cab Booking Hinjewadi",
    "description": "Book Ertiga cabs in Hinjewadi for local, corporate, or outstation travel. Great for transporting teams or families to events, tourist destinations, or meetings with reliable door-step pickup."
  },
  {
    "name": "Pune to Shirdi Ertiga Taxi",
    "description": "Travel from Pune to Shirdi in a comfortable Ertiga taxi. This 7-seater is ideal for religious trips with family or groups, offering a safe, smooth, and affordable journey."
  },
  {
    "name": "Affordable Ertiga Rental Pune",
    "description": "Looking for budget-friendly travel? Choose our affordable Ertiga rental service in Pune. Clean vehicles, transparent pricing, and no hidden fees ensure a stress-free travel experience."
  },
  {
    "name": "Ertiga for Marriage Event Pune",
    "description": "Book an Ertiga cab for wedding functions in Pune. Ideal for guest pickup, family transport, or vendor logistics with ample space and clean interiors to match the occasion."
  },
  {
    "name": "Long Trip Ertiga Pune",
    "description": "Planning a long trip from Pune? Our Ertiga rentals are ideal for extended travel across Maharashtra and beyond. Spacious interiors and trained drivers ensure a relaxing and enjoyable ride."
  },
  {
    "name": "Pune Ertiga Airport Pickup",
    "description": "Book Ertiga cabs for Pune Airport pickups — ideal for families or groups arriving with luggage. Timely arrival, professional drivers, and comfortable rides make airport transfers seamless."
  },
  {
    "name": "Ertiga for Local Travel Pune",
    "description": "Hire Ertiga cars in Pune for local sightseeing, errands, or daily commutes. This vehicle is great for families, offering air-conditioned comfort, ample space, and dependable service."
  }
],
"tableData": [
  ["Ertiga Rental Pune", "Ertiga Hire with Driver Pune"],
  ["7 Seater Ertiga Car Pune", "Pune to Mumbai Ertiga Booking"],
  ["Pune to Goa Ertiga Tour", "Ertiga for Outstation Pune"],
  ["Ertiga Cab for Family Trip Pune", "Ertiga on Rent Viman Nagar"],
  ["Ertiga Cab Booking Hinjewadi", "Pune to Shirdi Ertiga Taxi"],
  ["Affordable Ertiga Rental Pune", "Ertiga for Marriage Event Pune"],
  ["Long Trip Ertiga Pune", "Pune Ertiga Airport Pickup"],
  ["Ertiga for Local Travel Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Ertiga Rental Service in Pune",
    "WhyChoosedescription": "Prince Cabs offers dependable Ertiga rentals in Pune for a wide range of travel needs — from local sightseeing and outstation trips to airport transfers and family functions. Whether you're planning a one-day tour or a multi-day journey, our Ertiga rental service ensures comfort, space, and reliability at every step."
  },
  {
    "WhyChooseheading": "Spacious 7-Seater Perfect for Families and Groups",
    "WhyChoosedescription": "The Maruti Suzuki Ertiga is a practical 7-seater MUV that provides ample space for passengers and luggage. It's ideal for family outings, group travel, and corporate trips in and around Pune. With adjustable seating, generous legroom, and efficient air conditioning, your ride is guaranteed to be relaxing and comfortable."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Local and Outstation Use",
    "WhyChoosedescription": "Choose from a variety of rental options including hourly, full-day, and outstation packages. Whether you need an Ertiga for 4 hours, 8 hours, or multiple days, we have customizable plans to match your schedule and travel route. We also offer round-trip and one-way packages at competitive prices."
  },
  {
    "WhyChooseheading": "Experienced Drivers or Self-Drive Options",
    "WhyChoosedescription": "All Ertiga rentals come with professional, courteous drivers who know Pune city and nearby routes thoroughly. Prefer to drive yourself? We also offer self-drive Ertiga rentals with well-maintained vehicles, proper documentation, and 24/7 support for a worry-free trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our Ertiga rental rates in Pune are clear, affordable, and fully inclusive of fuel (where applicable), driver allowance, tolls, and taxes. You’ll receive a detailed fare breakdown before booking. Multiple payment options like UPI, credit/debit cards, net banking, and cash are available for your convenience."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
    "WhyChoosedescription": "Every Ertiga in our fleet is thoroughly sanitized and regularly serviced to ensure hygiene, safety, and mechanical reliability. From comfortable seating to air conditioning and modern safety features, our cabs are designed to offer a secure and pleasant experience for all passengers."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Experience",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, changes in plans, or any queries. Whether you're renting an Ertiga for a short city ride or a long-distance tour, our support ensures your journey is smooth, efficient, and stress-free from start to finish."
  }
]


































    }

const faqData = [
    {
        question: 'Can I rent an Ertiga in Pune through Prince Cabs?',
        answer: 'Yes, Prince Cabs offers Ertiga cars on rent in Pune for local travel, outstation trips, corporate events, and family tours.',
    },
    {
        question: 'What are the rental options available for Ertiga in Pune?',
        answer: 'We provide hourly, daily, and multi-day rental packages for Ertiga, depending on your travel requirements.',
    },
    {
        question: 'Is the Ertiga suitable for group and family travel?',
        answer: 'Absolutely! The Ertiga is a spacious MPV ideal for families and small groups, with comfortable seating for up to 6 passengers.',
    },
    {
        question: 'Are Ertiga vehicles from Prince Cabs well-maintained and sanitized?',
        answer: 'Yes, all Ertiga vehicles are regularly serviced, sanitized, and cleaned to ensure a safe and comfortable travel experience.',
    },
    {
        question: 'Does the rental include a driver?',
        answer: 'Yes, our Ertiga rentals come with experienced and courteous drivers for a hassle-free journey.',
    },
    {
        question: 'What is the rental fare for Ertiga in Pune?',
        answer: 'Rental fares vary based on trip duration, distance, and destination. Contact Prince Cabs for a customized quote.',
    },
    {
        question: 'How can I book an Ertiga on rent in Pune?',
        answer: 'You can book easily via our website or call our customer support team for immediate assistance and confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Nilesh Patil",
        position: "Corporate Client",
        text: "Prince Cabs provided us an Ertiga for a client visit in Pune. The vehicle was in excellent condition and the driver was very professional.",
        image: "/img/testimonial/testimonial-thumb-ertiga-rent-pune-1.png",
    },
    {
        name: "Ms. Aarti Deshmukh",
        position: "Tourist",
        text: "We rented an Ertiga from Prince Cabs for our family sightseeing tour in Pune. It was spacious, clean, and perfect for the trip.",
        image: "/img/testimonial/testimonial-thumb-ertiga-rent-pune-2.png",
    },
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Ertiga on Rent in Pune",
  "description": "Affordable 7 Seater Ertiga rental with driver in Pune for local travel, outstation trips, family tours, weddings, airport pickups, and long trips to Mumbai, Goa, Shirdi, and more.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Ertiga Rental Pune",
    "Ertiga Hire with Driver Pune",
    "7 Seater Ertiga Car Pune",
    "Pune to Mumbai Ertiga Booking",
    "Pune to Goa Ertiga Tour",
    "Ertiga for Outstation Pune",
    "Ertiga Cab for Family Trip Pune",
    "Ertiga on Rent Viman Nagar",
    "Ertiga Cab Booking Hinjewadi",
    "Pune to Shirdi Ertiga Taxi",
    "Affordable Ertiga Rental Pune",
    "Ertiga for Marriage Event Pune",
    "Long Trip Ertiga Pune",
    "Pune Ertiga Airport Pickup",
    "Ertiga for Local Travel Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Ertiga on Rent in Pune | Affordable 7 Seater Car Rental</title>
  <meta
    name="description"
    content="Book affordable 7 Seater Ertiga rental with driver in Pune for local travel, outstation trips, family tours, weddings, airport pickups, and long trips."
  />
  <meta
    name="keywords"
    content="Ertiga Rental Pune, Ertiga Hire with Driver Pune, 7 Seater Ertiga Car Pune, Pune to Mumbai Ertiga Booking, Pune to Goa Ertiga Tour, Ertiga for Outstation Pune, Ertiga Cab for Family Trip Pune, Ertiga on Rent Viman Nagar, Ertiga Cab Booking Hinjewadi, Pune to Shirdi Ertiga Taxi, Affordable Ertiga Rental Pune, Ertiga for Marriage Event Pune, Long Trip Ertiga Pune, Pune Ertiga Airport Pickup, Ertiga for Local Travel Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinpune ;